import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';

const Badge = ({
  className = 'bg-light',
  content,
  onClick,
  activeClass,
  style,
  withNoActive,
  notifyRemoveActive,
  rounded,
}) => {
  const activeState = activeClass || 'active';
  const badgeRef = useRef();

  const removeActive = useCallback(
    (ref) => {
      const allBadges = ref.closest('.d-flex').children;
      for (let i = 0; i < allBadges.length; i += 1) {
        const el = ref.closest('.d-flex').children[i];
        if (el !== ref) {
          el.classList.remove(activeState);
        }
      }
    },
    [activeState]
  );

  // This function is used to add active class to badge and remove it from not active ones
  const badgeClick = (e) => {
    if (withNoActive) {
      return;
    }
    removeActive(e.target);
    e.target.classList.toggle(activeState);
  };

  useEffect(() => {
    if (notifyRemoveActive && badgeRef.current) {
      removeActive(badgeRef.current);
    }
  }, [activeState, notifyRemoveActive, onClick, removeActive]);
  return (
    <span
      ref={badgeRef}
      className={`${
        className || 'px-2 py-1'
      } bg-lighter border border-disabled ${rounded} text-center text-f6 small-badge`}
      tabIndex={-1}
      style={style}
      onClick={(e) => {
        onClick();
        badgeClick(e, activeClass);
      }}
      onKeyDown={null}
      role="button">
      <b className="pe-none">{content}</b>
    </span>
  );
};

Badge.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  activeClass: PropTypes.string,
  rounded: PropTypes.string,
  withNoActive: PropTypes.bool,
  notifyRemoveActive: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object]),
};

Badge.defaultProps = {
  className: null,
  style: null,
  activeClass: 'active',
  rounded: 'rounded-4',
  withNoActive: false,
  notifyRemoveActive: false,
};

export default Badge;
